import { tv } from '~/utils/tv'

export const ContentActionsTextVariants = tv({
  base: `
     flex flex-col w-full items-start justify-start min-w-[2rem] flex-shrink bg-transparent gap-twopulse
  `,
  variants: {},
})
